import React from "react";

// Import logos from local assets
import mannLogo from "@common/assets/images/csr/mann.png";
import parisarAshaLogo from "@common/assets/images/csr/parisar-asha.png";
import helpingHandsLogo from "@common/assets/images/csr/helpinghands.png";
import karunyaLogo from "@common/assets/images/csr/kauaryan.png";
import roubleNagiLogo from "@common/assets/images/csr/rouble-nagi.png";
import snehaLogo from "@common/assets/images/csr/seha.png";
import rotaryClubLogo from "@common/assets/images/csr/roatry-club.png";

const CollaborativeInitiatives = () => {
  const partners = [
    {
      logo: mannLogo,
      title: "MANN - celebrating abilities",
      description:
        "We help reduce the financial burden on families by supplying essentials such as school uniforms, bags, umbrellas and learning essentials. This not only promotes regular attendance but also contributes to the overall well-being of the entire family.",
      alt: "MANN - Celebrating Abilities",
    },
    {
      logo: parisarAshaLogo,
      title: "PARISAR ASHA - centre for educational, research and training",
      description:"Parisar Asha’s Emotional Well-Being Program, supported by D’Décor since 2024, offers free, professional mental health support through a toll-free helpline and in-house counselling. Certified experts assist with stress, anxiety, addiction, and more. The program also conducts workshops for students, parents, and educators to promote emotional resilience.​",
      alt: "PARISAR ASHA - centre for educational, research and training",
    },
    {
      logo: helpingHandsLogo,
      title: "Helping Hands Foundation:",
      description:
        "Helping Hands Foundation is a non-profit organisation that works with children diagnosed with cancer. We are proud to be one of their corporate partners, supporting this meaningful mission.",
      alt: "Helping Hands Foundation",
    },
    {
      logo: karunyaLogo,
      title: "Karunya Trust : safety net to poor",
      description:"Karunya Trust empowers marginalized communities through education, healthcare, livelihood support, and shelter. We supports this mission by funding vocational training and income-generation programs, helping individuals build self-reliant and dignified lives.​",
      alt: "Karunya Trust : Safety Net to Poor",
    },
    {
      logo: roubleNagiLogo,
      title: "Rouble Nagi Art Foundation - education through art",
      description:"Rouble Nagi Art Foundation empowers underprivileged communities through skill development, vocational training, and quality education for children. Our organization support helps promote entrepreneurship, women’s empowerment, and self-reliance, while also driving initiatives in hygiene awareness and cleanliness. Together, we work toward building sustainable livelihoods and brighter futures.​",
      alt: "Rouble Nagi Art Foundation - Education through art",
    },
    {
      logo: snehaLogo,
      title: "Sneha: Raising For All",
      description:"SNEHA works to improve preventive and promotive healthcare for vulnerable women and children by addressing the social determinants of health. Through our CSR partnership, we support their efforts to strengthen public health systems and expand access to essential services and social protection in underserved communities.​",
      alt: "Sneha: Raising For All",
    },
    {
      logo: rotaryClubLogo,
      title: "Rotary Club of Mumbai",
      description:"through our CSR partnership with the Rotary Club of Mumbai, we support impactful initiatives in basic education, community economic development, maternal and child health, WASH (Water, Sanitation, and Hygiene), and peacebuilding. This collaboration transforms individual contributions into meaningful service projects that create lasting positive change in communities.​",
      alt: "Rotary Club of Mumbai",
    },
  ];

  return (
    <div className="bs-section bs-section--typ-csr-collaborative">
      <div className="bs-section__section-cont">
        <div className="bs-csr-collaborative-layout">
          {/* Header */}
          <div className="bs-csr-collaborative-layout__header">
            <h2 className="bs-csr-collaborative-layout__title">
              COLLABORATIVE
              <br />
              INITIATIVES
            </h2>
          </div>

          {/* Partners Grid */}
          <div className="bs-csr-collaborative-layout__grid bs-csr-collaborative-layout__grid--center-last">
            {partners.map((partner, index) => (
              <div
                key={index}
                className={`bs-csr-collaborative-layout__partner ${
                  index === partners.length - 1
                    ? "bs-csr-collaborative-layout__partner--last"
                    : ""
                }`}
              >
                <div className="bs-csr-collaborative-layout__partner-logo">
                  <img
                    src={partner.logo}
                    alt={partner.alt}
                    className="bs-csr-collaborative-layout__logo-img"
                  />
                </div>
                <h3 className="bs-csr-collaborative-layout__partner-title">
                  {partner.title}
                </h3>
                <p className="bs-csr-collaborative-layout__partner-description">
                  {partner.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollaborativeInitiatives;
